import { StationSummary } from "../../../../swagger-gen/gnvert-secured/models/station-summary";

export class UserAllowedStationModel {

    uid: string;
    name: string;
    code: string;

    constructor(res: StationSummary) {
        this.uid = res.uid;
        this.name = res.name || '';
        this.code = res.code || '';
    }

    public static getListFromApi(res: StationSummary[]): UserAllowedStationModel[] {
        const list: UserAllowedStationModel[] = [];
        if (res) {
            res.forEach(r => {
                list.push(new UserAllowedStationModel(r));
            });
        }

        return list;
    }
}
